<template>
    <div style="background-color: #e9e9e9">
        <Wp_nav_bar title="今日热推"
                    bColor="#e9e9e9"
                    border
                    border-style="1px solid #cccccc"
        ></Wp_nav_bar>
        <Wp_pull_list :url="url"
                 :all-params="all_params"
                 :page-size="all_params.size"
                 @onLoad="onLoad"
        >
            <div v-for="(item, index) in task_list" :key="index">
                <Wp_message_card_like_weixin :task-info="item"></Wp_message_card_like_weixin>
            </div>
        </Wp_pull_list>
<!--        <Wp_message_card_like_weixin :task-info="task_test"></Wp_message_card_like_weixin>-->
    </div>
</template>

<script>
    import Wp_message_card_like_weixin from "../custom/Wp_message_card_like_weixin";
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_pull_list from "../list/Wp_pull_list";
    import {Dialog} from 'vant';
    export default {
        name: "Wp_message_like_weixin",
        components: {Wp_pull_list, Wp_nav_bar, Wp_message_card_like_weixin},
        data(){
            return{
                task_test: {
                    "createtime": "2020-08-19 05:33:09",
                    "message_list": [
                        {
                            "nAtLocation": 0,
                            "nVoiceTime": 0,
                            "msgContent": "http://api.wapg.cn/jd_union//send_images/1597786326552.jpg",
                            "nIsHit": 0,
                            "nMsgNum": 1,
                            "vcAtWxSerialNos": [],
                            "nMsgType": 2002
                        },
                        {
                            "nAtLocation": 0,
                            "nVoiceTime": 0,
                            "msgContent": "✅✅竹臣氏 德国进口红橡木菜板切菜板砧板实木长方形案板擀面板 红橡木小号（38*28*2.2cm）\n \n✅✅红橡木木质坚硬强韧\n✅✅不易裂开 更耐用\n✅✅软硬适中 不伤刀\n✅✅实木制成 更放心\n—————————\n21.9元抢购竹臣氏楠竹木菜板\n抢券：https://u.jd.com/5RRHcs\n \n59元抢购竹臣氏德国进口红橡木菜板\n抢券：https://u.jd.com/hulXTM",
                            "nIsHit": 0,
                            "nMsgNum": 2,
                            "vcAtWxSerialNos": [],
                            "nMsgType": 2001
                        }
                    ],
                    "target_channel_name": "",
                    "task_status": 1,
                    "send_time": "15:15",
                    "send_day_order": 0,
                    "send_day": "2020-08-19",
                    "id": "1597786389039",
                    "target_group": ""
                },

                all_params: {
                    task_status: 1,
                    page: 1,
                    size: 20,
                },

                url: '',

                task_list: [],

                channel_name: '',
            }
        },

        created() {
            this.initDatas();
        },

        methods:{
            initDatas(){
                this.url = this.$common.robot_task_list_url;

                this.initUserData();
            },

            initUserData(){
                if(this.$common.isClient_whole()){
                    this.channel_name = this.$common.getUsername();
                    // Dialog.alert({
                    //     message: 'this.channel_name = ' + this.channel_name
                    // });
                    if(!this.channel_name){
                        let host = window.location.host;
                        // host = "S101.28pay.com";//test
                        // this.$log("host = " + host);
                        this.channel_name = host.substring(0, host.indexOf("."));
                    }
                    this.$log("this.channel_name = " + this.channel_name);
                    if (this.channel_name) {
                        this.$getPid(this.channel_name, res => {

                            if (res.code === 200) {
                                // let _channel_id=res.data.channel_id;
                                let _channel_id = res.data.jd_channel_id;
                                let _channel_name = res.data.channel_name;
                                let _channel_pdd_pid = '';
                                if (res.data.pdd_channel_id) {
                                    _channel_pdd_pid = res.data.pdd_channel_id;
                                }
                                let _channel_tb_pid = '';
                                if (res.data.tb_channel_id) {
                                    _channel_tb_pid = res.data.tb_channel_id;
                                }
                                let user = {
                                    username: _channel_name, //_channel_name
                                    userId: _channel_name,
                                    pid: _channel_id,
                                    pdd_pid: _channel_pdd_pid,
                                    tb_pid: _channel_tb_pid,
                                };
                                // this.$store.commit('login', user);
                                this.$store.commit("saveChannelData", user);
                            }
                        });
                    }
                }
            },

            onLoad(_list){
                this.task_list = _list
            }
        }
    }
</script>

<style scoped>

</style>